<footer class="footer w-100">
  <div class="content">
    <div class="row">
      <div class="col-12 col-lg-6 text-center text-lg-start mb-3 mb-lg-0">
        <h1 class="h4" i18n>Zentrale</h1>
        <div class="d-flex flex-column gap-3">
          <div class="d-flex flex-column flex-lg-row flex-wrap gap-lg-2 justify-content-center justify-content-lg-start align-items-center align-items-lg-baseline">
            <i class="bi bi-building"></i>
            <div class="d-flex flex-column">
              <span i18n>ser.soft GmbH</span>
              <span i18n>Gräfental 7</span>
              <span i18n>75057 Kürnbach</span>
            </div>
          </div>
          <div class="d-flex flex-column flex-lg-row flex-wrap gap-lg-2 justify-content-center justify-content-lg-start  align-items-center align-items-lg-baseline">
            <i class="bi bi-telephone"></i>
            <a href="tel:00497219351960" i18n>0721-93519-60</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 text-center text-lg-end">
        <h1 class="h4" i18n>Navigation</h1>
        <p>
          <a class="footer-link" [routerLink]="['/contact']" i18n>Kontakt</a><br/>
          <a class="footer-link" [routerLink]="['/imprint']" i18n>Impressum</a><br/>
          <a class="footer-link" [routerLink]="['/disclaimer']" i18n>Disclaimer</a><br/>
          <a class="footer-link" [routerLink]="['/privacy']" i18n>Datenschutz</a><br/>
        </p>
      </div>
      <div class="col-12 text-center my-2">
        <p style="margin-block-end: 0;" i18n>Sprache:</p>
        <div class="d-flex align-items-center justify-content-center">
          @for (language of languages; track language.code) {
            <button type="button" class="language-button"
                    (click)="switchLanguage(language)" [class.active]="locale() === language.code">
              <img [ngSrc]="language.flag.source" [alt]="language.name" class="lang-flag"
                   [width]="language.flag.size.width" [height]="language.flag.size.height" sizes="1.5rem">
            </button>
            @if (!$last) {
              <!-- Fixed px font size to get the same size as the img -->
              <span style="font-size: 24px;" class="pb-1 px-2">|</span>
            }
          }
        </div>
      </div>
      <div class="col-12 my-2">
        <p class="d-flex align-items-center justify-content-center gap-lg-1 flex-column flex-lg-row h5">
          <span i18n>&copy; 2016 - {{ currentYear }}</span>
          <span i18n>ser.soft GmbH</span>
        </p>
      </div>
    </div>
  </div>
</footer>
